import { createContext, FunctionComponent, PropsWithChildren, useState } from "react";

interface PageLoadedProviderProps {
  isLoading: boolean;
  disableLoading?: boolean;
}

export const PageLoadingContext = createContext<{
  isLoading: boolean;
  setRedirectionLoading: (redirectionLoading: boolean) => void;
  setGetCurrentUserLoading: (loading: boolean) => void;
}>({
  setRedirectionLoading: () => null,
  setGetCurrentUserLoading: () => null,
  isLoading: true,
});

export const PageLoadingProvider: FunctionComponent<PropsWithChildren<PageLoadedProviderProps>> = ({
  children,
  disableLoading,
  isLoading: isLoadingInitial,
}) => {
  const [redirectionLoading, setRedirectionLoading] = useState(false);
  const [getCurrentUserLoading, setGetCurrentUserLoading] = useState(true);

  if (isLoadingInitial) {
    return null;
  }

  return (
    <PageLoadingContext.Provider
      value={{
        setRedirectionLoading,
        setGetCurrentUserLoading,
        isLoading: (redirectionLoading || getCurrentUserLoading) && !disableLoading,
      }}
    >
      {children}
    </PageLoadingContext.Provider>
  );
};
